import FAQ from "components/Blocks/FAQ"

const faqContent = {
  sections: [
    {
      title: null,
      faqs: [
        {
          question: "What is embedded analytics?",
          answer:
            "Embedded analytics is the integration of data visualizations, dashboards, and reporting capabilities directly into your own software applications. Instead of users switching to a separate BI tool, they access analytics within your product's interface.",
        },
        {
          question: "How do I embed Preset dashboards in my application?",
          answer:
            "Preset offers multiple embedding options: iframe embedding for simple use cases, and the Embedded SDK for full control. The SDK supports React, Vue, Angular, and vanilla JavaScript. You generate a guest token from your backend and pass it to the SDK to securely render dashboards.",
        },
        {
          question:
            "Is embedded analytics secure for multi-tenant applications?",
          answer:
            "Yes. Preset supports Row-Level Security (RLS) which ensures each customer only sees their own data. Combined with guest tokens that encode user context, you can safely embed the same dashboard for multiple customers while keeping their data isolated.",
        },
        {
          question: "Can I customize the look of embedded dashboards?",
          answer:
            "Yes. Preset embedded dashboards support extensive customization including: hiding Preset UI elements (title bar, filters), custom CSS themes to match your brand, configurable filter visibility, and responsive sizing. Enterprise plans offer full white-labeling.",
        },
        {
          question: "What's the difference between iframe and SDK embedding?",
          answer:
            "Iframe embedding is simpler but offers less control — you just embed a URL. The SDK provides programmatic control: you can respond to filter changes, communicate between your app and the dashboard, handle authentication more securely, and customize the experience dynamically.",
        },
        {
          question: "Do embedded dashboards work on mobile devices?",
          answer:
            "Yes. Preset dashboards are responsive and work on mobile devices. The Embedded SDK handles responsive sizing automatically. You can also configure mobile-specific layouts and hide certain elements on smaller screens.",
        },
        {
          question: "How does guest token authentication work?",
          answer:
            "Your backend requests a guest token from Preset's API, specifying which resources (dashboards) the user can access and optionally their RLS context. This short-lived token is passed to the frontend SDK, which uses it to render the dashboard securely without exposing your API credentials.",
        },
        {
          question: "Can users interact with embedded dashboards?",
          answer:
            "Yes. Embedded dashboards are fully interactive. Users can apply filters, drill down into data, hover for tooltips, and explore. You can also pre-set filters via URL parameters or the SDK, and capture filter change events in your application.",
        },
      ],
    },
  ],
}

function FAQSection() {
  return (
    <FAQ
      label="Common Questions"
      heading="Frequently Asked Questions"
      content={faqContent}
    />
  )
}

export default FAQSection
